const TRANSLATIONS = {
  title: {
    de: 'Ihr interaktiver Studienplan',
    en: 'Your interactive study plan',
  },
  teaserCreateOnline: {
    de: 'Online erstellen',
    en: 'Create online',
  },
  startPageStartButton: {
    de: 'Loslegen',
    en: 'Start',
  },
  semestersLegendTitle: {
    de: 'Legende',
    en: 'Legend',
  },
  moduleTypeCompulsory: {
    de: 'Pflichtmodul',
    en: 'Compulsory module',
  },
  moduleTypeCoreElective: {
    de: 'Wahlpflichtmodul',
    en: 'Core elective module',
  },
  moduleTypeElective: {
    de: 'Wahlmodul',
    en: 'Elective module',
  },
  moduleTypeThesis: {
    de: 'Thesis',
  },
  moduleTypePracticeProject: {
    de: 'Praxisprojekt',
    en: 'Practice project',
  },
  moduleTypeLaboratory: {
    de: 'Labor',
    en: 'Laboratory',
  },
  moduleTypeResearchMethods: {
    de: 'Research Methods',
    en: 'Research methods',
  },
  modulePlaceholder: {
    de: '%s. Wahlpflichtmodul wählen',
    en: 'Select %s. elective module',
  },
  modulePlaceholderDescription: {
    de: 'Wählen Sie Ihre Schwerpunkte für das %s. Semester via Drag n’ drop.',
    en: 'Select your focus for the %s. Semester via drag n’ drop.',
  },
  moduleSize: {
    de: 'Umfang',
    en: 'Size',
  },
  moduleEctspoints: {
    de: '%s ECTS-Punkte',
    en: '%s ECTS points',
  },
  moduleSemester: {
    de: '%s Semester',
    en: '%s Semester',
  },
  chooseModule: {
    de: 'Wahlpflichtmodule wählen',
    en: 'Choose compulsory module',
  },
  toOverview: {
    de: 'Zur Übersicht',
    en: 'To the overview',
  },
  goToSemester: {
    de: 'Zum %s',
    en: 'To %s',
  },
  overviewGoToSemester: {
    de: 'Zum %s. Semester',
    en: 'To %s. semester',
  },
  linkCopied: {
    de: 'Link kopiert',
    en: 'Link copied',
  },
  couldNotSaveToClipboard: {
    de: 'Konnte nicht in die Zwischenablage speichern',
    en: 'Could not save to clipboard',
  },
  yourStudyplan: {
    de: 'Ihr persönlicher Studienplan',
    en: 'Your personal study plan',
  },
  studyplanAsPdf: {
    de: 'Studienplan als PDF downloaden',
    en: 'Download studyplan as PDF',
  },
  modulesAsPdf: {
    de: 'Modulübersicht als PDF downloaden',
    en: 'Download module overview as PDF',
  },
  copyLink: {
    de: 'Link kopieren',
    en: 'Copy link',
  },
  overview: {
    de: 'Übersicht',
    en: 'Overview',
  },
};

export const localize = window.sfp.scriptLibs.createLocalize(TRANSLATIONS);
